import { CommonEnum } from './../guard/common-enum';
import { SharedService } from './shared.service';
import { Injectable, Inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
//import { CommonEnum } from './common-enum';



declare const Pusher: any;

@Injectable()
export class PusherService {

  pusher: any;
  channel: any;
  usuario: any = '';
  id: any;
  private _messages$: Subject<any>;
  public messages: Observable<any>;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private _sharedService: SharedService
  ) {
    this.usuario = this.storage.get('Usuario');

    let data = {
      auth_token: this._sharedService.getCookie(CommonEnum.cookieName)
    };
    this.inicializePusher();
    
    if (!this.usuario) {
        this._sharedService.getCurrent(data).subscribe(res => {
        //console.log("Esto me retorna el shared Service: ", res);
        this.id = res.data.id;
        //console.log("Este es el id: ", this.id);
        this.channel = this.pusher.subscribe(`my-channel${this.id}`);
          //console.log("Este es el chanel: ", this.channel);
          this.eventPusher(data);
      }, error => {
        console.log("Ups!, Hubo un error: ", error);
      });
    } else {
     // console.log(this.usuario);
      this.channel = this.pusher.subscribe('my-channel'+this.usuario.id);
      //console.log("Este es el chanel después: ", this.channel);
      this.eventPusher(data);
    }
    this._messages$ = new Subject<any>();
    this.messages = this._messages$.asObservable();
    //this.channel = this.pusher.subscribe(`my-channel`);
    //console.log("entro al pusher");
    
  }

  inicializePusher() {
    this.pusher = new Pusher(
      environment.pusher.key, {
      cluster: environment.pusher.cluster,
      encrypted: true,
      forceTLS: true
    });
  }

  eventPusher(datas: any) {
    //console.log("channel: ", this.channel);
    //console.log("Data dentro de event pusher: ", datas);
    this.channel.bind('my-event', (datas) => this._messages$.next(datas));
    //} 
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/shared/pusher.service.ts